export const environment = {
  production: true,
  name:'prod',
  url: 'https://api.serasaexperian.com.br',
  urlAnalitico: 'https://api.serasaexperian.com.br',
  urlProtocolo: 'https://api.serasaexperian.com.br/cadastro-positivo/protocolo/',
  securityIamBasePath: 'https://api.serasaexperian.com.br/security/iam/v1',
  urlAnaliticoHistorico: 'https://api.serasaexperian.com.br/lgpd/analitico/v1/history',
  urlHistoricoPedidoDownload: 'https://api.serasaexperian.com.br/lgpd/analitico/v1/download',



  urlPortalEntrar: 'https://www.serasa.com.br/entrar',
  urlRedirecionamento : 'https://www.serasa.com.br/protecao-dados-pessoais/',
  urlRedirecionamentoRelatorioSintetico : 'https://www.serasa.com.br/protecao-dados-pessoais/relatorio-sintetico',
  urlRedirecionamentoRelatorioAnalitico : 'https://www.serasa.com.br/protecao-dados-pessoais/relatorio-analitico',
  urlRedirecionamentoHistSolicitacoes : 'https://www.serasa.com.br/protecao-dados-pessoais/historico-solicitacoes',
  urlPortal: 'https://www.serasa.com.br',
  certificateAuthentication: '5ed12383bc49b56d675d97e2',

  gaTrackingId:'GTM-5XS8NFS'
};